import Axios from '../plugins/axios'

export const fetchLanguages = function () {
    return Axios.get('languages')
}

export const createLanguage = function (language) {
    return Axios.post('languages', language);
}

export const createIdentifier = function (identifier, group) {
    return Axios.post('languages/identifiers', { name: identifier, group })
}

export const createString = function (languageCode, groupId, identifierId, content) {
    return Axios.post('languages/strings', { languageCode, groupId, identifierId, content })
}

export const deleteIdentifier = function (identifierId) {
    return Axios.delete('languages/identifiers/' + identifierId);
}